import { render, staticRenderFns } from "./ContractUs.vue?vue&type=template&id=15198e85&scoped=true&"
import script from "./ContractUs.vue?vue&type=script&lang=js&"
export * from "./ContractUs.vue?vue&type=script&lang=js&"
import style0 from "./ContractUs.vue?vue&type=style&index=0&id=15198e85&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15198e85",
  null
  
)

export default component.exports